module.exports = __webpack_public_path__ + "img/index24.4574b975.png";